var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirectUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/direct-up"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/direct-up_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "direct-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.3378 6.67611L6.17058 10.4849C3.99428 11.3874 3.60741 14.3481 5.60656 14.791L8.82214 14.2033C9.46935 14.3467 9.93492 14.8123 10.0783 15.4595L9.70887 18.8934C10.1518 20.8925 13.1081 20.5012 14.0151 18.3293L17.8238 9.1621C18.5731 7.3587 17.1412 5.92685 15.3378 6.67611Z",
    stroke: "#0D429F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectUp);
export default __webpack_public_path__ + "static/media/direct-up.6beaa2f189b28cc084e77e55b63632f9.svg";
export { ForwardRef as ReactComponent };